import { Image, makeStyles, Text } from "@fluentui/react-components";
import TitleText from "../../../components/titleText/TitleText";
import IPageIcons, { IIcon } from "../../../models/page/pageComponents/IPageIcons";

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexDirection: "column",
        padding: "0 2rem",
        maxWidth: "1200px",
        margin: "0 auto",
        justifyContent: "center",
        alignItems: "center",
        
        "@media (max-width: 768px)": {
            marginTop: "1rem",
        },
    },
    itemsContainer: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        gap: "20px",
        width: "100%",
    },
    item: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexBasis: "30%",
        padding: "1rem",
        boxSizing: "border-box",

        "& h3": {
            fontWeight: "bold",
            marginBottom: "0.5rem",
        },

        "& p": {
            textAlign: "center",
            color: "#869ab8"
        },

        "@media (max-width: 768px)": {
            flexBasis: "100%",
        },
    },
    iconWrapper: {
        display: "flex",
        height: "72px",
        alignItems: "center",
        justifyContent: "center",
    },
    icon: {
        width: "72px",
        height: "auto",
        maxHeight: "72px",
        marginBottom: "1rem",
    }
});

const Item = (props: { item: IIcon }) => {
    const styles = useStyles();

    return (
        <div className={styles.item}>
            <div className={styles.iconWrapper}>
                <Image src={props.item.image.url} alt={props.item.image.altText} className={styles.icon} />
            </div>

            <Text as="h3" size={500}>{props.item.title}</Text>
            <Text as="p" size={400}>{props.item.text}</Text>
        </div>
    );
}

export default function ServiceIcon(props: IPageIcons) {
    const styles = useStyles();

    return (
        <div className={styles.container}>
            <TitleText
                title={props.title}
                titleHighlightedWords={props.titleHighlightedWords}
                subtitle={props.subtitle}
                alignment="center"
                width="100%"
                />
                
            <div className={styles.itemsContainer}>
                {
                    props.items.map((item, index) => <Item key={index} item={item} />)
                }
            </div>
        </div>
    );
}